import { Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import './styles.scss';
import React, { useState } from 'react';
import SearchInput from 'components/base/search-input';
import { DealAnalyticsType } from 'models/deals.model';

const tableHeaders = ['NAME', 'NO. OF USERS', 'USAGE COUNT', 'REVENUE(₦)'];

type Props = {
  analyticsData: DealAnalyticsType[];
  loading: boolean;
};
const PerformanceOverviewTable = ({ analyticsData, loading }: Props) => {
  const [searchValue, setSearchValue] = useState('');

  return (
    <div className='border-gray-1  border rounded-lg'>
      <div className='flex justify-between items-center  p-4 '>
        <h5 className='font-medium '>Deal Breakdown</h5>
        <div className='flex gap-5'>
          <div>
            <SearchInput value={searchValue} handleChange={(e) => setSearchValue(e.target.value)} />
          </div>
        </div>
      </div>
      <Table loading={loading} headers={tableHeaders}>
        {analyticsData?.map((deal, idx) => (
          <TableRow
            key={deal?.discount_code}
            className={`hover:bg-gray-light/80  ${
              analyticsData.length - 1 === idx ? 'border-none' : ''
            }`}>
            <TableData>
              <p className='capitalize'>{deal?.discount_code}</p>
            </TableData>
            <TableData>
              <p>{deal?.user_count}</p>
            </TableData>
            <TableData>
              <p>{deal?.no_of_times_used}</p>
            </TableData>
            <TableData>
              <p>{deal.overall_total_revenue.toLocaleString()}.00</p>
            </TableData>
          </TableRow>
        ))}
      </Table>
    </div>
  );
};

export default PerformanceOverviewTable;
